export enum RangeType {
    ClusterGeneric = 1,
    StoreScan = 2,
    FairShare = 3,
    AdHoc = 4,
    ClusterGenericProposed = 5,
    StoreScanProposed = 6,
    Preview = 7,
    OnShelf = 8,
    Custom = 9
}